module.exports = __webpack_public_path__ + "static/media/smoke_false_active.38ed383b.jpg";